export default "__VITE_ASSET__Dzn$4il___"